<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>SJAN  T20 Cricket Tournament  </h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm fide-chess2021 section-banner-bg-1">
    <div class="container">
        <!-- <div class="sec-title text-center">
            <h2>SJAN  T20 Cricket Tournament </h2>
        </div> -->
        <p class="card-text">Defending champions Lokmat will take on Loksatta in the opening encounter of 25th Inter-Press Invitational T20 Cricket Tournament being organised by Sports Journalists’ Association of Nagpur (SJAN) in association with Shalinitai Meghe Hospital and Research Centre (SMHRC) at Vasant Nagar ground at 8.30 am on Friday.</p>

            <p>The tournament will be inaugurated by Sagar Meghe, Principal Advisor, DMIHER (Deemed University).</p>

            <p>Dr Anup Marar, CEO (Health Care), Meghe Group of Institutions Director, DMIHER (DU) Off Campus, Dr Mrunal Naik, Preoecj Head, GH Raisoni Sports and Cultural Foundation, will also share the dais.</p>

            <p>On Thursday, dresses for the tournament were distributed to the teams at the hands of Dr Marar, project head of GH Raisoni Sports and Cultural Foundation Dr Mrunal Naik and Director (Marketing) SMHRC Amit Das.</p>

            <p>SJAN Secretary Paritosh Pramanik and vice-president Amit Sampat also shared the dais.</p>

            <p>Nine teams including Lokmat, Punyanagari, Sakal, Tarun Bharat, Times of India, Loksatta, Danik Bhaskar, Navbharat and Deshonnati are taking part in this silver jubilee edition of the meet.</p>

            <p>The tournament is also supported by Raisoni Education, Sports Karma, Sarangi Foundation Trust, MOIL. Matches will be played in coloured clothing and with white Wisden County balls.</p>
        <div class="lightBox--gallery">
            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/sjan-t20-tournament.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/sjan-t20-tournament.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/sjan-t20-tournament.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/sjan-t20-tournament1.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/sjan-t20-tournament1.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/sjan-t20-tournament1.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/sjan-t20-tournament2.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/sjan-t20-tournament2.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/sjan-t20-tournament2.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/sjan-t20-tournament3.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/sjan-t20-tournament3.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/sjan-t20-tournament3.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/sjan-t20-tournament4.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/sjan-t20-tournament4.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/sjan-t20-tournament4.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/sjan-t20-tournament5.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/sjan-t20-tournament5.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/sjan-t20-tournament5.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <!-- <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/checkmate-challenge-6.avif"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/checkmate-challenge-6.avif">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/checkmate-challenge-6.avif"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/checkmate-challenge-7.avif"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/checkmate-challenge-7.avif">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/checkmate-challenge-7.avif"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li> -->
            </ul>
        </div>
    </div>
</section>
